import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/draggable.css';
import $ from 'jquery';

import UISubElement from './UISubElement';
import type NavMenu from './NavMenu';
import DesktopManager from './DesktopManager';

export default class NavSubMenu extends UISubElement<NavMenu> {
  public static readonly Selector: string = '.nav-item.nav-has-submenu';

  public readonly trigger: HTMLInputElement;
  public readonly $frame: JQuery<HTMLElement>;
  public readonly desktopManager: DesktopManager;

  private _attached: boolean = true;

  public get attached(): boolean {
    return this._attached;
  }

  public constructor(
    parent: NavMenu,
    element: HTMLElement,
    desktopManager: DesktopManager,
  ) {
    super(parent, element);
    this.trigger = (
      this.$element
        .find('input.nav-item-expand-trigger')
        .first() as JQuery<HTMLInputElement>
    ).get()[0];
    this.$frame = this.$element.find('.nav-submenu-frame').first();
    this.desktopManager = desktopManager;
  }

  public override mount(): void {
    this.$frame.draggable({
      handle: '.nav-submenu-title-bar',
      stack: '.nav-submenu-frame',
      scroll: true,
      zIndex: 1000,
      start: () => {
        this._attached = false;
        this.$frame.addClass('detached');
      },
      drag: (_, ui) => {
        this.onDrag(ui);
      },
    });

    $(this.trigger).on('change', () => {
      if (this.trigger.checked) {
        this.parent.closeOtherAttachedSubmenus(this);
        this.bringToFront();
      }
    });

    this.$frame.on('click', this.bringToFront.bind(this));

    this.$frame
      .find('.nav-submenu-button.close-button')
      .on('click', this.onCloseButtonClick.bind(this));
  }

  public close() {
    this.trigger.checked = false;
    this._attached = true;
    this.$frame
      .css('top', '')
      .css('left', '')
      .css('z-index', '')
      .removeClass('detached');
  }

  // noinspection JSDeprecatedSymbols
  private onDrag(ui: JQueryUI.DraggableEventUIParams) {
    const objectHeight: number = this.$frame.outerHeight() || 0;
    const objectWidth: number = this.$frame.outerWidth() || 0;
    const objectBottom: number = ui.offset.top + objectHeight;
    const objectRight: number = ui.offset.left + objectWidth;
    const bounds = this.desktopManager.checkAndAdjustBounds(objectRight, objectBottom);

    if (ui.offset.top < 0) {
      ui.position.top += -ui.offset.top;
    }

    if (ui.offset.left < 0) {
      ui.position.left += -ui.offset.left;
    }

    if (objectBottom > bounds.height) {
      ui.position.top -= objectBottom - bounds.height;
    }

    if (objectRight > bounds.width) {
      ui.position.left -= objectRight - bounds.width;
    }
  }

  private bringToFront() {
    const highestZIndex =
      Math.max(
        ...$('.nav-submenu-frame')
          .map((_, elem) => {
            return Number.parseInt($(elem).css('z-index') || '0');
          })
          .get(),
      ) || 0;
    this.$frame.css('z-index', highestZIndex + 1);
  }

  private onCloseButtonClick(ev: JQuery.ClickEvent) {
    this.close();
    ev.stopPropagation();
  }
}
